import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const OrderTable = (props) => {
  let { formControls } = props

  return (
    <div className="c-personalizer-product-table">

      { formControls.type.value !== '' ? (
        <div className="c-personalizer-product-table__row u-flex">
          <div className="c-personalizer-product-table__title">Soort mat</div>
          <div className="c-personalizer-product-table__content">
            {formControls.use.value} {formControls.type.value}
          </div>
        </div>
      ) : null }

      { formControls.thickness.value !== '' ? (
        <div className="c-personalizer-product-table__row u-flex">
          <div className="c-personalizer-product-table__title">Matdikte</div>
          <div className="c-personalizer-product-table__content">
            {formControls.thickness.value} mm
          </div>
        </div>
      ) : null }

      { formControls.rubberEdge.value !== '' ? (
        <div className="c-personalizer-product-table__row u-flex">
          <div className="c-personalizer-product-table__title">Randafwerking</div>
          <div className="c-personalizer-product-table__content">
            {formControls.rubberEdge.value}
          </div>
        </div>
      ) : null }

      { formControls.length.value !== '' ? (
        <div className="c-personalizer-product-table__row u-flex">
          <div className="c-personalizer-product-table__title">Lengte</div>
          <div className="c-personalizer-product-table__content">
            {formControls.length.value} cm
          </div>
        </div>
      ) : null }

      { formControls.width.value !== '' ? (
        <div className="c-personalizer-product-table__row u-flex">
          <div className="c-personalizer-product-table__title">Breedte</div>
          <div className="c-personalizer-product-table__content">
            {formControls.width.value} cm
          </div>
        </div>
      ) : null }

      { formControls.corners.value !== '' ? (
        <div className="c-personalizer-product-table__row u-flex">
          <div className="c-personalizer-product-table__title">Aantal uitsnedes</div>
          <div className="c-personalizer-product-table__content">
            {formControls.corners.value}
          </div>
        </div>
      ) : null }
      
      { formControls.cutter.value !== '' ? (
        <div className="c-personalizer-product-table__row u-flex">
          <div className="c-personalizer-product-table__title">Snijmes toevoegen</div>
          <div className="c-personalizer-product-table__content">
            {formControls.cutter.value}
          </div>
        </div>
      ) : null }

      { formControls.file.fileName !== '' ? (
        <div className="c-personalizer-product-table__row u-flex">
          <div className="c-personalizer-product-table__title">Opdruk</div>
          <div className="c-personalizer-product-table__content">
            {formControls.file.fileName}
          </div>
        </div>
      ) : null }

    </div>
  )
}

export default OrderTable



// WEBPACK FOOTER //
// ./src/js/personalizer/components/OrderTable.js